// extracted by mini-css-extract-plugin
module.exports = {"mainModalBox":"tooltip_mainModalBox__GxzzY"};